import React, { useEffect, useState, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Drawer from "@material-ui/core/Drawer";
import Link from "@material-ui/core/Link";
import InputLabel from "@material-ui/core/InputLabel";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import MergeTypeIcon from '@material-ui/icons/MergeType';
import GroupIcon from '@material-ui/icons/Group';
import SyncIcon from '@material-ui/icons/Sync';
import ChatIcon from '@material-ui/icons/Chat';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Divider from "@material-ui/core/Divider";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "@material-ui/core/Tooltip";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LinkIcon from "@material-ui/icons/Link";
import ImageIcon from "@material-ui/icons/Image";
import DescriptionIcon from "@material-ui/icons/Description";
import VideocamIcon from "@material-ui/icons/Videocam";

import { i18n } from "../../translate/i18n";

import ContactDrawerSkeleton from "../ContactDrawerSkeleton";
import MarkdownWrapper from "../MarkdownWrapper";
import { CardHeader } from "@material-ui/core";
import { ContactForm } from "../ContactForm";
import { ContactTagsContainer } from "../ContactTagsContainer";
import ContactModal from "../ContactModal";
import { ContactNotes } from "../ContactNotes";
import MergeContactModal from "../MergeContactModal";
import { getClienteLabel } from "../TicketInfo";
import NewTicketModal from "../NewTicketModal";
import ContactStatusAvatar from "../ContactStatusAvatar";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/Auth/AuthContext";
import { SocketContext } from "../../context/Socket/SocketContext";
import MediaGalleryViewer, { fetchMediaGallery, toMediaGalleryItem } from "../MediaGalleryViewer";

const drawerWidth = 320;

const useStyles = makeStyles(theme => ({
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
		display: "flex",
		borderTop: "1px solid rgba(0, 0, 0, 0.12)",
		borderRight: "1px solid rgba(0, 0, 0, 0.12)",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		borderTopRightRadius: 4,
		borderBottomRightRadius: 4,
	},
	header: {
		display: "flex",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		backgroundColor: theme.palette.contactdrawer, //DARK MODE PLW DESIGN//
		alignItems: "center",
		padding: theme.spacing(0, 1),
		minHeight: "73px",
		justifyContent: "flex-start",
	},
	content: {
		display: "flex",
		backgroundColor: theme.palette.contactdrawer, //DARK MODE PLW DESIGN//
		flexDirection: "column",
		padding: "8px 0px 8px 8px",
		height: "100%",
		overflowY: "scroll",
		...theme.scrollbarStyles,
	},

	contactAvatar: {
		margin: 15,
		width: 100,
		height: 100,
	},

	contactHeader: {
		display: "flex",
		padding: 8,
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		"& > *": {
			margin: 4,
		},
		// Permite o conteudo do CardHeader encolher para o noWrap
		// truncar com reticencias em vez de estourar a largura
		"& .MuiCardHeader-content": {
			minWidth: 0,
		},
	},

	contactDetails: {
		marginTop: 8,
		padding: 8,
		display: "flex",
		flexDirection: "column",
	},
	contactExtraInfo: {
		marginTop: 4,
		padding: 6,
	},
	groupParticipantsList: {
		maxHeight: 300,
		overflowY: "auto",
		...theme.scrollbarStyles,
	},
	participantItem: {
		paddingTop: 4,
		paddingBottom: 4,
	},
	syncButton: {
		marginLeft: 8,
	},
	chatButton: {
		padding: 4,
	},
	favoriteMessageBody: {
		display: "-webkit-box",
		WebkitLineClamp: 2,
		WebkitBoxOrient: "vertical",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "normal",
		overflowWrap: "anywhere",
	},
	favoriteMessageSender: {
		fontWeight: 600,
		marginBottom: 2,
	},
	favoriteMessageMeta: {
		display: "block",
		marginTop: 4,
	},
	favoritePreviewImage: {
		width: 56,
		height: 56,
		borderRadius: 6,
		objectFit: "cover",
		marginRight: 10,
		border: "1px solid rgba(0, 0, 0, 0.12)",
	},
	favoriteMessageRow: {
		display: "flex",
		alignItems: "flex-start",
		width: "100%",
	},
	favoriteMessageContent: {
		minWidth: 0,
		flex: 1,
	},
	sharedTabs: {
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		marginBottom: 8,
		width: "100%",
	},
	sharedTabRoot: {
		minWidth: 0,
		maxWidth: "33.333%",
		flex: "0 0 33.333%",
	},
	favoriteScrollableList: {
		maxHeight: 700,
		overflowY: "auto",
		overflowX: "hidden",
		...theme.scrollbarStyles,
	},
	sharedScrollableList: {
		maxHeight: 420,
		overflowY: "auto",
		overflowX: "hidden",
		...theme.scrollbarStyles,
	},
	sharedItemThumb: {
		width: 56,
		height: 56,
		borderRadius: 6,
		objectFit: "cover",
		marginRight: 10,
		border: "1px solid rgba(0, 0, 0, 0.12)",
	},
	sharedItemRow: {
		display: "flex",
		alignItems: "flex-start",
		width: "100%",
	},
	sharedItemContent: {
		minWidth: 0,
		flex: 1,
	},
	sharedItemTitle: {
		display: "block",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		minWidth: 0,
		fontWeight: 500,
	},
	sharedItemUrl: {
		display: "block",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		minWidth: 0,
	},
}));

const SHARED_TAB_KEYS = ["media", "docs", "links"];

// Itens por janela da aba Mídia (mesmo tamanho das páginas de Documentos/Links).
const SHARED_MEDIA_PAGE_SIZE = 20;

const ContactDrawer = ({ open, handleDrawerClose, contact, ticket, loading, onJumpToMessage, galleryTicketId, contactHistoryFilter, whatsappStatus }) => {
	const classes = useStyles();
	const history = useHistory();
	const { user } = useContext(AuthContext);
	const socketManager = useContext(SocketContext);
	const realtimeRefreshTimeoutRef = useRef(null);
	const favoritesOpenRef = useRef(false);
	const sharedTabValueRef = useRef(0);

	const [modalOpen, setModalOpen] = useState(false);
	const [openForm, setOpenForm] = useState(false);
	const [mergeModalOpen, setMergeModalOpen] = useState(false);
	const [groupParticipants, setGroupParticipants] = useState([]);
	const [loadingParticipants, setLoadingParticipants] = useState(false);
	const [syncingParticipants, setSyncingParticipants] = useState(false);
	const [lastSyncAt, setLastSyncAt] = useState(null);
	const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
	const [selectedParticipantContact, setSelectedParticipantContact] = useState(null);
	const [loadingParticipantAction, setLoadingParticipantAction] = useState(null);
	const [favoritesOpen, setFavoritesOpen] = useState(false);
	const [extraInfoOpen, setExtraInfoOpen] = useState(false);
	const [favoriteMessages, setFavoriteMessages] = useState([]);
	const [favoriteCount, setFavoriteCount] = useState(0);
	const [favoritesPage, setFavoritesPage] = useState(1);
	const [favoritesHasMore, setFavoritesHasMore] = useState(false);
	const [loadingFavorites, setLoadingFavorites] = useState(false);
	const [loadingFavoriteCount, setLoadingFavoriteCount] = useState(false);
	const [sharedTabValue, setSharedTabValue] = useState(0);
	const [sharedItems, setSharedItems] = useState({ media: [], docs: [], links: [] });
	const [sharedPage, setSharedPage] = useState({ media: 1, docs: 1, links: 1 });
	const [sharedHasMore, setSharedHasMore] = useState({ media: false, docs: false, links: false });
	const [sharedLoading, setSharedLoading] = useState({ media: false, docs: false, links: false });
	const [mediaViewerItem, setMediaViewerItem] = useState(null);

	useEffect(() => {
		favoritesOpenRef.current = favoritesOpen;
	}, [favoritesOpen]);

	useEffect(() => {
		sharedTabValueRef.current = sharedTabValue;
	}, [sharedTabValue]);

	// Chamado que limita a galeria (mídia/documentos/links). Só faz diferença no
	// modo "Por ticket" para quem não tem a permissão de histórico completo — quem
	// decide é o backend; aqui só informamos o chamado em tela. Na aba Contatos
	// não há chamado aberto, e o ContactChat passa o ticket escolhido no seletor.
	const sharedTicketId =
		galleryTicketId !== undefined
			? galleryTicketId
			: ticket?.id && !ticket?._isContactChat && !/^contact-/.test(String(ticket.id))
				? ticket.id
				: null;
	const sharedTicketIdRef = useRef(sharedTicketId);

	useEffect(() => {
		sharedTicketIdRef.current = sharedTicketId;
	}, [sharedTicketId]);

	// Aba Mídia e visualizador: o mesmo escopo do histórico da tela ao lado (o
	// chamado aberto, ou o contato com o seletor da aba Contatos) — a ficha nunca
	// lista uma foto que a conversa esconde.
	const isContactChat = Boolean(ticket?._isContactChat) || /^contact-/.test(String(ticket?.id || ""));
	const mediaGallerySource = contact?.id && isContactChat
		? {
			kind: "contact",
			contactId: contact.id,
			filter: {
				ticketId: contactHistoryFilter?.ticketId,
				whatsappId: contactHistoryFilter?.whatsappId,
				viewAll: contactHistoryFilter?.viewAll,
			},
		}
		: ticket?.id
			? { kind: "ticket", ticketId: ticket.id }
			: null;
	const mediaSourceKey = mediaGallerySource ? JSON.stringify(mediaGallerySource) : "";
	const mediaGallerySourceRef = useRef(mediaGallerySource);
	mediaGallerySourceRef.current = mediaGallerySource;

	// Verificar se é um grupo baseado em múltiplos critérios:
	// 1. Flag isGroup do contato (pode ser boolean, 1, "1", true, "true")
	// 2. Número termina com @g.us
	// 3. Número tem formato XXXXX-XXXXX@g.us (grupos)
	// 4. Número é um ID longo de grupo sem hífen (grupos novos: 120363...)
	// NOTA: @lid é usado para contatos INDIVIDUAIS, não para grupos!
	const isGroup = 
		contact?.isGroup === true || 
		contact?.isGroup === 1 || 
		contact?.isGroup === "1" ||
		contact?.isGroup === "true" ||
		contact?.number?.includes("@g.us") || 
		/^\d+-\d+@g\.us$/.test(contact?.number) || // Formato: 554291453904-1477669484@g.us
		/^120363\d+@g\.us$/.test(contact?.number); // Formato: 120363406792162043@g.us

	useEffect(() => {
		setOpenForm(false);
	}, [open, contact]);

	useEffect(() => {
		setFavoritesOpen(false);
		setExtraInfoOpen(false);
		setFavoriteMessages([]);
		setFavoriteCount(0);
		setFavoritesPage(1);
		setFavoritesHasMore(false);
		setLoadingFavorites(false);
		setLoadingFavoriteCount(false);
		setSharedTabValue(0);
		setSharedItems({ media: [], docs: [], links: [] });
		setSharedPage({ media: 1, docs: 1, links: 1 });
		setSharedHasMore({ media: false, docs: false, links: false });
		setSharedLoading({ media: false, docs: false, links: false });
	}, [open, contact?.id]);

	useEffect(() => {
		const loadFavoritesCount = async () => {
			if (!open || !contact?.id) return;

			setLoadingFavoriteCount(true);
			try {
				const { data } = await api.get(`/messages/contact/${contact.id}/favorites`, {
					params: { pageNumber: 1 }
				});
				setFavoriteCount(Number(data?.count || 0));
				setFavoritesHasMore(Boolean(data?.hasMore));
			} catch (err) {
				setFavoriteCount(0);
			} finally {
				setLoadingFavoriteCount(false);
			}
		};

		loadFavoritesCount();
	}, [open, contact?.id]);

	const getFavoriteMessagePreview = (message) => {
		if (!message) return "";
		if (message.isDeleted) return i18n.t("contactDrawer.favorites.messageDeleted");
		const body = String(message.body || "").trim();
		if (body) return body;
		if (message.mediaType === "image" || message.mediaType === "imageMessage") {
			return i18n.t("contactDrawer.favorites.image");
		}
		if (message.mediaType) {
			const mediaLabel = i18n.t("contactDrawer.favorites.media");
			return `${mediaLabel} (${message.mediaType})`;
		}
		return i18n.t("contactDrawer.favorites.messageWithoutContent");
	};

	const isFavoriteImageMessage = (message) => {
		if (!message) return false;
		const mediaType = String(message.mediaType || "").toLowerCase();
		if (!["image", "imagemessage"].includes(mediaType)) return false;
		return Boolean(String(message.mediaUrl || "").trim());
	};

	const getFavoriteSenderName = (message) => {
		if (!message) return "";

		if (message.fromMe) {
			return String(
				message.userName ||
				message.sign ||
				user?.name ||
				i18n.t("contactDrawer.favorites.senderYou")
			);
		}

		if (message.dataJson) {
			try {
				const parsedData = typeof message.dataJson === "string" ? JSON.parse(message.dataJson) : message.dataJson;
				if (parsedData?.pushName) return String(parsedData.pushName);
				if (parsedData?.verifiedBizName) return String(parsedData.verifiedBizName);
				if (parsedData?.notify) return String(parsedData.notify);
			} catch (_err) {
				// ignore parse errors
			}
		}

		if (message.contact?.name) return String(message.contact.name);
		if (message.participant) return String(message.participant).split("@")[0].split(":")[0];
		return i18n.t("contactDrawer.favorites.senderContact");
	};

	const formatFavoriteDate = (dateValue) => {
		if (!dateValue) return "";
		const parsed = new Date(dateValue);
		if (Number.isNaN(parsed.getTime())) return "";
		return parsed.toLocaleString();
	};

	const getSharedTabKey = (tabValue = 0) => SHARED_TAB_KEYS[tabValue] || "media";

	const getSharedEndpoint = (tabKey) => {
		if (tabKey === "docs") return `/messages/contact/${contact.id}/documents`;
		return `/messages/contact/${contact.id}/${tabKey}`;
	};

	const getSharedMediaLabel = (message) => {
		const mediaType = String(message?.mediaType || "").toLowerCase();
		if (mediaType.includes("video")) {
			return i18n.t("contactDrawer.shared.video");
		}
		return i18n.t("contactDrawer.shared.image");
	};

	const getDocumentFileName = (message) => {
		const mediaUrl = String(message?.mediaUrl || "").trim();
		if (!mediaUrl) {
			return i18n.t("contactDrawer.shared.document");
		}

		try {
			const rawName = mediaUrl.split("?")[0].split("/").pop() || "";
			const decoded = decodeURIComponent(rawName);
			return decoded || i18n.t("contactDrawer.shared.document");
		} catch (_err) {
			return mediaUrl.split("?")[0].split("/").pop() || i18n.t("contactDrawer.shared.document");
		}
	};

	const getSharedItemTitle = (tabKey, message) => {
		if (tabKey === "links") {
			return message?.linkUrl || message?.linkNormalizedUrl || i18n.t("contactDrawer.shared.link");
		}

		if (tabKey === "docs") {
			return String(message?.body || "").trim() || getDocumentFileName(message);
		}

		return String(message?.body || "").trim() || getSharedMediaLabel(message);
	};

	const loadSharedMedia = async ({ page, reset }) => {
		const source = mediaGallerySourceRef.current;
		if (!source) {
			setSharedItems((prev) => ({ ...prev, media: [] }));
			setSharedHasMore((prev) => ({ ...prev, media: false }));
			return;
		}

		const requestedSourceKey = JSON.stringify(source);
		// A lista fica da mais nova para a mais antiga: a próxima janela parte da última.
		const oldest = reset ? null : sharedItems.media[sharedItems.media.length - 1];
		const { items, hasOlder } = await fetchMediaGallery(source, {
			direction: "older",
			cursorId: oldest?.id,
			limit: SHARED_MEDIA_PAGE_SIZE
		});

		// A fonte mudou com a requisição em voo: a resposta é da anterior.
		if (JSON.stringify(mediaGallerySourceRef.current) !== requestedSourceKey) return;

		const incomingMessages = items.map((item) => item.message).reverse();
		setSharedItems((prev) => ({
			...prev,
			media: reset ? incomingMessages : [...prev.media, ...incomingMessages]
		}));
		setSharedPage((prev) => ({ ...prev, media: page }));
		setSharedHasMore((prev) => ({ ...prev, media: hasOlder }));
	};

	const loadSharedItems = async (tabKey, { page = 1, reset = false, force = false } = {}) => {
		if (!contact?.id || (sharedLoading[tabKey] && !force)) return;

		const requestedTicketId = sharedTicketIdRef.current;
		setSharedLoading((prev) => ({ ...prev, [tabKey]: true }));
		try {
			if (tabKey === "media") {
				await loadSharedMedia({ page, reset });
				return;
			}

			const { data } = await api.get(getSharedEndpoint(tabKey), {
				params: {
					pageNumber: page,
					...(requestedTicketId ? { ticketId: requestedTicketId } : {})
				}
			});

			// O chamado mudou com a requisição em voo: a resposta é do anterior.
			if (sharedTicketIdRef.current !== requestedTicketId) return;

			const incomingMessages = Array.isArray(data?.messages) ? data.messages : [];

			setSharedItems((prev) => ({
				...prev,
				[tabKey]: reset ? incomingMessages : [...prev[tabKey], ...incomingMessages]
			}));
			setSharedPage((prev) => ({ ...prev, [tabKey]: page }));
			setSharedHasMore((prev) => ({ ...prev, [tabKey]: Boolean(data?.hasMore) }));
		} catch (err) {
			toastError(err);
		} finally {
			setSharedLoading((prev) => ({ ...prev, [tabKey]: false }));
		}
	};

	const handleSharedTabChange = (_event, newValue) => {
		setSharedTabValue(newValue);
		const tabKey = getSharedTabKey(newValue);
		if (!sharedItems[tabKey]?.length) {
			loadSharedItems(tabKey, { page: 1, reset: true });
		}
	};

	const handleLoadMoreShared = async () => {
		const tabKey = getSharedTabKey(sharedTabValue);
		if (sharedLoading[tabKey] || !sharedHasMore[tabKey]) return;
		await loadSharedItems(tabKey, { page: Number(sharedPage[tabKey] || 1) + 1, reset: false });
	};

	const handleFavoritesScroll = async (event) => {
		if (loadingFavorites || !favoritesHasMore) return;

		const target = event.currentTarget;
		const threshold = 80;
		const reachedBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - threshold;

		if (reachedBottom) {
			await loadFavoriteMessages({ page: favoritesPage + 1, reset: false });
		}
	};

	const handleSharedScroll = async (event) => {
		const tabKey = getSharedTabKey(sharedTabValue);
		if (sharedLoading[tabKey] || !sharedHasMore[tabKey]) return;

		const target = event.currentTarget;
		const threshold = 80;
		const reachedBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - threshold;

		if (reachedBottom) {
			await handleLoadMoreShared();
		}
	};

	// Trocar de chamado (ou de seletor da aba Contatos) muda o que a galeria pode
	// mostrar: recomeça da aba Mídia. O reset geral (abrir/trocar de contato) fica
	// no efeito acima.
	useEffect(() => {
		setSharedTabValue(0);
		setSharedItems({ media: [], docs: [], links: [] });
		setSharedPage({ media: 1, docs: 1, links: 1 });
		setSharedHasMore({ media: false, docs: false, links: false });
		setMediaViewerItem(null);
	}, [sharedTicketId, mediaSourceKey]);

	useEffect(() => {
		if (!open || !contact?.id) return;
		// force: a carga do chamado anterior pode estar em voo, e a resposta dela
		// é descartada em loadSharedItems.
		loadSharedItems("media", { page: 1, reset: true, force: true });
	}, [open, contact?.id, sharedTicketId, mediaSourceKey]);

	useEffect(() => {
		if (!open || !contact?.id || !user?.companyId) {
			return undefined;
		}

		const socket = socketManager.getSocket(user.companyId);

		const scheduleRefresh = () => {
			if (realtimeRefreshTimeoutRef.current) {
				clearTimeout(realtimeRefreshTimeoutRef.current);
			}

			realtimeRefreshTimeoutRef.current = setTimeout(async () => {
				setLoadingFavoriteCount(true);
				try {
					const { data } = await api.get(`/messages/contact/${contact.id}/favorites`, {
						params: { pageNumber: 1 }
					});

					setFavoriteCount(Number(data?.count || 0));
					setFavoritesHasMore(Boolean(data?.hasMore));
					if (favoritesOpenRef.current) {
						setFavoriteMessages(Array.isArray(data?.messages) ? data.messages : []);
						setFavoritesPage(1);
					}
				} catch (_err) {
					// Ignore transient realtime refresh failures.
				} finally {
					setLoadingFavoriteCount(false);
				}

				const currentTab = getSharedTabKey(sharedTabValueRef.current);
				await loadSharedItems(currentTab, { page: 1, reset: true });
			}, 350);
		};

		const handleRealtimeAppMessage = (data) => {
			if (!data || (data.action !== "create" && data.action !== "update")) {
				return;
			}

			const message = data?.message;
			if (!message) {
				return;
			}

			const messageContactId = Number(message?.contactId || data?.contact?.id || 0);
			if (!messageContactId || messageContactId !== Number(contact.id)) {
				return;
			}

			scheduleRefresh();
		};

		socket.on(`company-${user.companyId}-appMessage`, handleRealtimeAppMessage);

		return () => {
			if (realtimeRefreshTimeoutRef.current) {
				clearTimeout(realtimeRefreshTimeoutRef.current);
			}
			socket.off(`company-${user.companyId}-appMessage`, handleRealtimeAppMessage);
		};
	}, [open, contact?.id, user?.companyId, socketManager]);

	const handleOpenFavoriteMessage = async (message) => {
		if (!message?.id) return;
		const isJumpDebugEnabled = (() => {
			try {
				if (typeof window === "undefined") return false;
				const byStorage = window.localStorage?.getItem("jumpDebug") === "1";
				const byQuery = new URLSearchParams(window.location.search).get("jumpDebug") === "1";
				return byStorage || byQuery;
			} catch (_err) {
				return false;
			}
		})();

		if (isJumpDebugEnabled) {
			console.log("[JumpDebug][ContactDrawer] favorite-click", {
				messageId: message.id,
				messageTicketId: message?.ticketId || message?.ticket?.id || null,
				messageTicketUuid: message?.ticketUuid || message?.ticket?.uuid || null,
				currentTicketId: ticket?.id || null,
				currentTicketUuid: ticket?.uuid || null,
			});
		}

		const currentTicketUuid = ticket?.uuid || null;

		// Na aba Contatos a lista já exibe todo o histórico do contato, então dá
		// para saltar in-place mesmo sem chamado aberto. O pseudo-ticket dessa aba
		// não tem uuid, e exigir uuid mandava o usuário para o chamado antigo.
		if (
			!currentTicketUuid &&
			ticket?._isContactChat &&
			typeof onJumpToMessage === "function"
		) {
			if (typeof handleDrawerClose === "function") {
				handleDrawerClose();
			}

			if (isJumpDebugEnabled) {
				console.log("[JumpDebug][ContactDrawer] dispatch-jump-contact-chat", {
					messageId: message.id,
					contactId: contact?.id || null,
				});
			}

			setTimeout(() => onJumpToMessage(String(message.id)), 120);
			return;
		}

		if (currentTicketUuid) {
			if (typeof handleDrawerClose === "function") {
				handleDrawerClose();
			}

			if (typeof onJumpToMessage === "function") {
				if (isJumpDebugEnabled) {
					console.log("[JumpDebug][ContactDrawer] dispatch-jump-callback", {
						messageId: message.id,
						currentTicketUuid,
					});
				}
				setTimeout(() => onJumpToMessage(String(message.id)), 120);
			} else {
				if (isJumpDebugEnabled) {
					console.log("[JumpDebug][ContactDrawer] navigate-same-ticket", {
						messageId: message.id,
						currentTicketUuid,
					});
				}
				setTimeout(() => {
					history.push(`/tickets/${currentTicketUuid}`, {
						jumpToMessageId: String(message.id),
						jumpToMessageTs: Date.now(),
					});
				}, 120);
			}
			return;
		}

		const targetTicketId = message?.ticketId || message?.ticket?.id || null;
		let targetTicketUuid = message?.ticketUuid || message?.ticket?.uuid || null;

		if (!targetTicketUuid && targetTicketId) {
			try {
				const { data } = await api.get(`/tickets/${targetTicketId}`);
				targetTicketUuid = data?.uuid || null;
				if (isJumpDebugEnabled) {
					console.log("[JumpDebug][ContactDrawer] resolved-ticket-by-id", {
						targetTicketId,
						targetTicketUuid,
					});
				}
			} catch (_err) {
				targetTicketUuid = null;
				if (isJumpDebugEnabled) {
					console.log("[JumpDebug][ContactDrawer] failed-resolve-ticket-by-id", {
						targetTicketId,
					});
				}
			}
		}

		if (!targetTicketUuid) {
			toast.warning(i18n.t("contactDrawer.favorites.ticketNotFound"));
			if (isJumpDebugEnabled) {
				console.log("[JumpDebug][ContactDrawer] ticket-not-found", {
					messageId: message.id,
					targetTicketId,
				});
			}
			return;
		}

		if (isJumpDebugEnabled) {
			console.log("[JumpDebug][ContactDrawer] navigate-target-ticket", {
				messageId: message.id,
				targetTicketUuid,
			});
		}

		history.push(`/tickets/${targetTicketUuid}`, {
			jumpToMessageId: String(message.id),
			jumpToMessageTs: Date.now(),
		});
	};

	const loadFavoriteMessages = async ({ page = 1, reset = false } = {}) => {
		if (!contact?.id || loadingFavorites) return;

		setLoadingFavorites(true);
		try {
			const { data } = await api.get(`/messages/contact/${contact.id}/favorites`, {
				params: { pageNumber: page }
			});

			const incomingMessages = Array.isArray(data?.messages) ? data.messages : [];
			setFavoriteCount(Number(data?.count || 0));
			setFavoritesHasMore(Boolean(data?.hasMore));
			setFavoritesPage(page);

			if (reset) {
				setFavoriteMessages(incomingMessages);
			} else {
				setFavoriteMessages((prev) => [...prev, ...incomingMessages]);
			}
		} catch (err) {
			toastError(err);
		} finally {
			setLoadingFavorites(false);
		}
	};

	const handleToggleFavorites = async () => {
		const nextOpen = !favoritesOpen;
		setFavoritesOpen(nextOpen);

		if (nextOpen && favoriteMessages.length === 0) {
			await loadFavoriteMessages({ page: 1, reset: true });
		}
	};

	// Carregar participantes do grupo quando abrir
	// O backend já faz auto-sync se os dados tiverem mais de 24h
	useEffect(() => {
		const fetchGroupParticipants = async () => {
			if (!open || !contact?.id || !isGroup) {
				setGroupParticipants([]);
				return;
			}

			setLoadingParticipants(true);
			try {
				// Backend faz auto-sync automático se dados > 24h
				const { data } = await api.get(`/contacts/${contact.id}/participants`);
				setGroupParticipants(data.participants || []);
				setLastSyncAt(data.lastSyncAt);
				
				if (data.autoSynced) {
					console.log("[GroupParticipants] Dados foram atualizados automaticamente");
				}
			} catch (err) {
				console.log("Erro ao carregar participantes:", err);
				setGroupParticipants([]);
			} finally {
				setLoadingParticipants(false);
			}
		};

		fetchGroupParticipants();
	}, [open, contact?.id, isGroup]);

	const handleSyncParticipants = async () => {
		if (!contact?.id || syncingParticipants) return;

		setSyncingParticipants(true);
		try {
			const { data } = await api.post(`/contacts/${contact.id}/participants/sync`);
			setGroupParticipants(data.participants || []);
			setLastSyncAt(data.lastSyncAt || new Date().toISOString());
			toast.success(i18n.t("contactDrawer.members.synced"));
		} catch (err) {
			toastError(err);
		} finally {
			setSyncingParticipants(false);
		}
	};
	
	// Formatar data da última sincronização
	const formatLastSync = (dateStr) => {
		if (!dateStr) return null;
		const date = new Date(dateStr);
		const now = new Date();
		const diffMs = now - date;
		const diffMins = Math.floor(diffMs / 60000);
		const diffHours = Math.floor(diffMs / 3600000);
		const diffDays = Math.floor(diffMs / 86400000);
		
		if (diffMins < 1) return i18n.t("contactDrawer.members.lastSync.now");
		if (diffMins < 60) return i18n.t("contactDrawer.members.lastSync.minutes", { count: diffMins });
		if (diffHours < 24) return i18n.t("contactDrawer.members.lastSync.hours", { count: diffHours });
		return i18n.t("common.time.daysAgo", { count: diffDays });
	};

	// Iniciar conversa com um participante do grupo
	const handleStartConversation = async (participant) => {
		if (!participant?.contactId) {
			toast.warning(i18n.t("contactDrawer.members.participantNotLinked"));
			return;
		}

		setLoadingParticipantAction(participant.id);
		
		try {
			// Buscar o contato completo
			const { data: contactData } = await api.get(`/contacts/${participant.contactId}`);
			
			// Verificar se existe ticket aberto com este contato
			const { data: ticketsData } = await api.get("/tickets", {
				params: {
					contactId: participant.contactId,
					status: "open,pending",
					showAll: "true",
				},
			});

			const tickets = ticketsData.tickets || [];

			if (tickets.length > 0) {
				// Procurar ticket do próprio usuário primeiro
				const myOpenTicket = tickets.find(
					(t) => t.status === "open" && t.userId === user.id
				);

				if (myOpenTicket) {
					history.push(`/tickets/${myOpenTicket.uuid}`);
					setLoadingParticipantAction(null);
					return;
				}

				// Procurar ticket na fila (pending)
				const pendingTicket = tickets.find((t) => t.status === "pending");

				if (pendingTicket) {
					try {
						await api.put(`/tickets/${pendingTicket.id}`, {
							status: "open",
							userId: user.id,
						});
						history.push(`/tickets/${pendingTicket.uuid}`);
						setLoadingParticipantAction(null);
						return;
					} catch (err) {
						toastError(err);
						setLoadingParticipantAction(null);
						return;
					}
				}

				// Se existe ticket aberto mas de outro atendente
				const otherOpenTicket = tickets.find(
					(t) => t.status === "open" && t.userId !== user.id
				);

				if (otherOpenTicket) {
					const attendantName = otherOpenTicket.user?.name || i18n.t("contactDrawer.members.anotherAttendant");
					toast.info(i18n.t("contactDrawer.members.alreadyAttended", { name: attendantName }));
					setLoadingParticipantAction(null);
					return;
				}
			}

			// Se não existe ticket, abrir modal para criar novo
			setSelectedParticipantContact(contactData);
			setNewTicketModalOpen(true);
			setLoadingParticipantAction(null);
			
		} catch (err) {
			toastError(err);
			setLoadingParticipantAction(null);
		}
	};

	// Callback quando um novo ticket é criado
	const handleCloseNewTicketModal = (ticket) => {
		setNewTicketModalOpen(false);
		setSelectedParticipantContact(null);
		if (ticket !== undefined && ticket.uuid !== undefined) {
			history.push(`/tickets/${ticket.uuid}`);
		}
	};

	const handleMergeSuccess = () => {
		setMergeModalOpen(false);
		setOpenForm(false);
		toast.success(i18n.t("contactDrawer.toasts.merged"));
	};

	return (
		<>
			<Drawer
				className={classes.drawer}
				variant="persistent"
				anchor="right"
				open={open}
				PaperProps={{ style: { position: "absolute" } }}
				BackdropProps={{ style: { position: "absolute" } }}
				ModalProps={{
					container: document.getElementById("drawer-container"),
					style: { position: "absolute" },
				}}
				classes={{
					paper: classes.drawerPaper,
				}}
			>
				<div className={classes.header}>
					<IconButton onClick={handleDrawerClose}>
						<CloseIcon />
					</IconButton>
					<Typography style={{ justifySelf: "center" }}>
						{isGroup 
							? (i18n.t("contactDrawer.headerGroup") || "Dados do Grupo")
							: i18n.t("contactDrawer.header")}
					</Typography>
				</div>
				{loading ? (
					<ContactDrawerSkeleton classes={classes} />
				) : (
					<div className={classes.content}>
						<Paper square variant="outlined" className={classes.contactHeader}>
							<CardHeader
								onClick={() => {}}
								style={{ cursor: "pointer", width: '100%' }}
								titleTypographyProps={{ noWrap: true }}
								subheaderTypographyProps={{ noWrap: true }}
								avatar={
									<ContactStatusAvatar
										contact={contact}
										stories={whatsappStatus?.stories}
										ticketId={ticket?.id}
										style={{ width: 60, height: 60 }}
									/>
								}
								title={
									<>
										<Typography onClick={() => setOpenForm(true)}>
											{contact?.name || ''}
										</Typography>
									</>
								}
								subheader={
									<>
										{!isGroup && contact?.number && (
											<Typography style={{fontSize: 12}}>
												<Link href={`tel:${contact.number}`}>{contact.number}</Link>
											</Typography>
										)}
										{!isGroup && !contact?.number && contact?.instagramUsername && (
											<Typography style={{fontSize: 12}}>
												<Link href={`https://instagram.com/${contact.instagramUsername}`} target="_blank" rel="noreferrer">
													@{contact.instagramUsername}
												</Link>
											</Typography>
										)}
										{!isGroup && whatsappStatus?.about?.text && (
											<Typography
												style={{ fontSize: 12, fontStyle: "italic" }}
												color="textSecondary"
												noWrap
												title={whatsappStatus.about.text}
											>
												{whatsappStatus.about.text}
											</Typography>
										)}
										{!isGroup && getClienteLabel(contact) && (
											<Typography style={{fontSize: 12, fontWeight: 500}} noWrap title={getClienteLabel(contact)}>
												{getClienteLabel(contact)}
											</Typography>
										)}
										{contact?.email && (
											<Typography style={{fontSize: 12}}>
												<Link href={`mailto:${contact.email}`}>{contact.email}</Link>
											</Typography>
										)}
										{isGroup && (
											<Typography style={{fontSize: 12, color: "#666"}}>
												<GroupIcon style={{fontSize: 14, verticalAlign: "middle", marginRight: 4}} />
												{groupParticipants.length > 0 
													? i18n.t("contactDrawer.members.count", { count: groupParticipants.length })
													: i18n.t("contactDrawer.members.groupLabel")
												}
											</Typography>
										)}
									</>
								}
							/>
							<Button
								variant="outlined"
								color="primary"
								onClick={() => setModalOpen(!openForm)}
								style={{fontSize: 12}}
							>
								{i18n.t("contactDrawer.buttons.edit")}
							</Button>
							{!isGroup && (
								<Button
									variant="outlined"
									color="secondary"
									onClick={() => setMergeModalOpen(true)}
									style={{fontSize: 12, marginTop: 8}}
									startIcon={<MergeTypeIcon />}
								>
									{i18n.t("contactDrawer.buttons.merge")}
								</Button>
							)}
							{(contact.id && openForm) && <ContactForm initialContact={contact} onCancel={() => setOpenForm(false)} isGroup={isGroup} />}
						</Paper>
						<ContactModal
							open={modalOpen}
							onClose={() => setModalOpen(false)}
							contactId={contact.id}
							isGroup={isGroup}
						></ContactModal>
						<Paper square variant="outlined" className={classes.contactDetails}>
							<Typography variant="subtitle1" style={{marginBottom: 10}}>
								{i18n.t("contactModal.form.tags")}
							</Typography>
							<ContactTagsContainer contact={contact} />
						</Paper>
						{contact?.extraInfo?.length > 0 && (
							<Paper square variant="outlined" className={classes.contactDetails}>
								<List dense disablePadding>
									<ListItem button onClick={() => setExtraInfoOpen(v => !v)}>
										<ListItemText
											primary={i18n.t("contactDrawer.extraInfo")}
											secondary={`${contact.extraInfo.length}`}
										/>
										{extraInfoOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
									</ListItem>
								</List>
								{extraInfoOpen && (
									<>
										<Divider style={{ margin: "8px 0" }} />
										{contact.extraInfo.map(info => (
											<Paper
												key={info.id}
												square
												variant="outlined"
												className={classes.contactExtraInfo}
											>
												<InputLabel>{info.name}</InputLabel>
												<Typography component="div" noWrap style={{ paddingTop: 2 }}>
													<MarkdownWrapper>{info.value}</MarkdownWrapper>
												</Typography>
											</Paper>
										))}
									</>
								)}
							</Paper>
						)}
						<Paper square variant="outlined" className={classes.contactDetails}>
							<Typography variant="subtitle1" style={{marginBottom: 10}}>
								{i18n.t("ticketOptionsMenu.appointmentsModal.title")}
							</Typography>
							<ContactNotes ticket={ticket} />
						</Paper>
						<Paper square variant="outlined" className={classes.contactDetails}>
							<List dense disablePadding>
								<ListItem button onClick={handleToggleFavorites}>
									<ListItemAvatar>
										<Avatar>
											<StarBorderIcon fontSize="small" />
										</Avatar>
									</ListItemAvatar>
									<ListItemText
										primary={i18n.t("contactDrawer.favorites.title")}
										secondary={
											loadingFavoriteCount
												? i18n.t("contactDrawer.favorites.loading")
												: (favoriteCount > 0 ? `${favoriteCount}` : i18n.t("contactDrawer.favorites.none"))
										}
									/>
									{favoritesOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
								</ListItem>
							</List>

							{favoritesOpen && (
								<>
									<Divider style={{ margin: "8px 0" }} />
									{loadingFavorites && favoriteMessages.length === 0 ? (
										<div style={{ display: "flex", justifyContent: "center", padding: 12 }}>
											<CircularProgress size={22} />
										</div>
									) : (
										<>
											{favoriteMessages.length === 0 ? (
												<Typography variant="body2" style={{ color: "#666", padding: 8 }}>
													{i18n.t("contactDrawer.favorites.noMessages")}
												</Typography>
											) : (
												<div className={classes.favoriteScrollableList} onScroll={handleFavoritesScroll}>
												<List dense>
													{favoriteMessages.map((message) => (
															<ListItem
																key={`favorite-${message.id}`}
																alignItems="flex-start"
																button
																onClick={() => (
																	isFavoriteImageMessage(message) && !message.isDeleted
																		? setMediaViewerItem(toMediaGalleryItem(message))
																		: handleOpenFavoriteMessage(message)
																)}
															>
															<ListItemText
																primary={
																		<div className={classes.favoriteMessageRow}>
																			{isFavoriteImageMessage(message) && (
																				<img
																					src={message.mediaUrl}
																					alt={i18n.t("contactDrawer.favorites.previewAlt")}
																					className={classes.favoritePreviewImage}
																				/>
																			)}
																			<div className={classes.favoriteMessageContent}>
																				<Typography variant="caption" className={classes.favoriteMessageSender}>
																					{getFavoriteSenderName(message)}
																				</Typography>
																				<Typography variant="body2" className={classes.favoriteMessageBody}>
																					{getFavoriteMessagePreview(message)}
																				</Typography>
																			</div>
																		</div>
																}
																secondary={
																		<Typography variant="caption" color="textSecondary" className={classes.favoriteMessageMeta}>
																			{message?.ticketId ? `${i18n.t("contactDrawer.favorites.ticketLabel")} #${message.ticketId}` : ""}
																			{message?.createdAt ? ` • ${formatFavoriteDate(message.createdAt)}` : ""}
																		</Typography>
																}
															/>
														</ListItem>
													))}
												</List>
												</div>
											)}

											{loadingFavorites && favoriteMessages.length > 0 && (
												<div style={{ display: "flex", justifyContent: "center", paddingTop: 8 }}>
													<CircularProgress size={18} />
												</div>
											)}
										</>
									)}
								</>
							)}
						</Paper>
						<Paper square variant="outlined" className={classes.contactDetails}>
							<Tabs
								value={sharedTabValue}
								onChange={handleSharedTabChange}
								indicatorColor="primary"
								textColor="primary"
								variant="fullWidth"
								className={classes.sharedTabs}
							>
								<Tab classes={{ root: classes.sharedTabRoot }} label={i18n.t("contactDrawer.shared.mediaTab")} />
								<Tab classes={{ root: classes.sharedTabRoot }} label={i18n.t("contactDrawer.shared.docsTab")} />
								<Tab classes={{ root: classes.sharedTabRoot }} label={i18n.t("contactDrawer.shared.linksTab")} />
							</Tabs>

							{(() => {
								const activeKey = getSharedTabKey(sharedTabValue);
								const activeItems = sharedItems[activeKey] || [];
								const isLoading = sharedLoading[activeKey];

								if (isLoading && activeItems.length === 0) {
									return (
										<div style={{ display: "flex", justifyContent: "center", padding: 12 }}>
											<CircularProgress size={22} />
										</div>
									);
								}

								if (!activeItems.length) {
									return (
										<Typography variant="body2" style={{ color: "#666", padding: 8 }}>
											{i18n.t(`contactDrawer.shared.empty.${activeKey}`)}
										</Typography>
									);
								}

								return (
									<>
										<div className={classes.sharedScrollableList} onScroll={handleSharedScroll}>
											<List dense>
												{activeItems.map((item) => (
													<ListItem
														key={`${activeKey}-${item?.linkId || item.id}`}
														alignItems="flex-start"
														button
														onClick={() => (
															activeKey === "media"
																? setMediaViewerItem(toMediaGalleryItem(item))
																: handleOpenFavoriteMessage(item)
														)}
													>
														<ListItemText
															primary={
																<div className={classes.sharedItemRow}>
																	{activeKey === "media" && String(item?.mediaType || "").toLowerCase().includes("image") && item?.mediaUrl ? (
																		<img
																			src={item.mediaUrl}
																			alt={i18n.t("contactDrawer.shared.previewAlt")}
																			className={classes.sharedItemThumb}
																		/>
																	) : activeKey === "media" && item?.mediaThumbUrl ? (
																		// Vídeo: a miniatura embutida pelo WhatsApp no lugar do ícone.
																		<img
																			src={item.mediaThumbUrl}
																			alt={i18n.t("contactDrawer.shared.previewAlt")}
																			className={classes.sharedItemThumb}
																		/>
																	) : (
																		<ListItemAvatar>
																			<Avatar>
																				{activeKey === "links" ? <LinkIcon fontSize="small" /> : activeKey === "docs" ? <DescriptionIcon fontSize="small" /> : String(item?.mediaType || "").toLowerCase().includes("video") ? <VideocamIcon fontSize="small" /> : <ImageIcon fontSize="small" />}
																			</Avatar>
																		</ListItemAvatar>
																	)}
																	<div className={classes.sharedItemContent}>
																		<Typography variant="body2" className={classes.sharedItemTitle} title={getSharedItemTitle(activeKey, item)}>
																			{getSharedItemTitle(activeKey, item)}
																		</Typography>
																		{activeKey === "links" && item?.linkDomain ? (
																			<Typography variant="caption" color="textSecondary" className={classes.sharedItemUrl} title={item.linkDomain}>
																				{item.linkDomain}
																			</Typography>
																		) : null}
																	</div>
																</div>
															}
															secondary={
																<Typography variant="caption" color="textSecondary" className={classes.favoriteMessageMeta}>
																	{item?.ticketId ? `${i18n.t("contactDrawer.favorites.ticketLabel")} #${item.ticketId}` : ""}
																	{item?.createdAt ? ` • ${formatFavoriteDate(item.createdAt)}` : ""}
																</Typography>
															}
														/>
													</ListItem>
												))}
											</List>
										</div>

										{sharedLoading[activeKey] && activeItems.length > 0 && (
											<div style={{ display: "flex", justifyContent: "center", paddingTop: 8 }}>
												<CircularProgress size={18} />
											</div>
										)}
									</>
								);
							})()}
						</Paper>

						{/* Seção de Membros do Grupo */}
						{isGroup && (
							<Paper square variant="outlined" className={classes.contactDetails}>
								<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
									<div>
										<Typography variant="subtitle1">
											<GroupIcon style={{fontSize: 18, verticalAlign: "middle", marginRight: 8}} />
											{i18n.t("contactDrawer.members.title")}
										</Typography>
										{lastSyncAt && (
											<Typography variant="caption" style={{ color: "#888", marginLeft: 26 }}>
												{i18n.t("contactDrawer.members.updated", { when: formatLastSync(lastSyncAt) })}
											</Typography>
										)}
									</div>
									<IconButton 
										size="small" 
										onClick={handleSyncParticipants}
										disabled={syncingParticipants || loadingParticipants}
										title={i18n.t("contactDrawer.members.syncTooltip")}
										className={classes.syncButton}
									>
										{syncingParticipants ? (
											<CircularProgress size={20} />
										) : (
											<SyncIcon />
										)}
									</IconButton>
								</div>
								
								{loadingParticipants ? (
									<div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 16 }}>
										<CircularProgress size={24} />
										<Typography variant="caption" style={{ marginTop: 8, color: "#666" }}>
											{i18n.t("contactDrawer.members.syncing")}
										</Typography>
									</div>
								) : groupParticipants.length > 0 ? (
									<List className={classes.groupParticipantsList}>
										{groupParticipants.map((participant, index) => {
											// Determinar o nome a exibir (prioridade: displayName > número)
											const name = participant.displayName || participant.participantNumber || i18n.t("common.unknown");
											// Verificar se é apenas número para mostrar de forma diferente
											const isJustNumber = /^\d+$/.test(name);
											const displayName = isJustNumber ? participant.participantNumber : name;
											const isLoading = loadingParticipantAction === participant.id;
											
											return (
												<React.Fragment key={participant.id || index}>
													{index > 0 && <Divider />}
													<ListItem 
														className={classes.participantItem}
													>
														<ListItemAvatar>
															<Avatar 
																src={participant.profilePicUrl?.includes?.('nopicture') ? undefined : participant.profilePicUrl}
																style={{ width: 32, height: 32 }}
															>
																{displayName?.charAt(0)?.toUpperCase()}
															</Avatar>
														</ListItemAvatar>
														<ListItemText
															primary={
																<Typography variant="body2">
																	{displayName}
																	{participant.isSuperAdmin && (
																		<Typography 
																			component="span" 
																			variant="caption" 
																			style={{ 
																				marginLeft: 8, 
																				backgroundColor: "#e3f2fd",
																				color: "#1976d2",
																				padding: "2px 6px",
																				borderRadius: 4
																			}}
																		>
																			{i18n.t("contactDrawer.members.admin")}
																		</Typography>
																	)}
																	{participant.isAdmin && !participant.isSuperAdmin && (
																		<Typography 
																			component="span" 
																			variant="caption" 
																			style={{ 
																				marginLeft: 8, 
																				backgroundColor: "#e3f2fd",
																				color: "#1976d2",
																				padding: "2px 6px",
																				borderRadius: 4
																			}}
																		>
																			{i18n.t("contactDrawer.members.admin")}
																		</Typography>
																	)}
																</Typography>
															}
															secondary={
																// Se o nome não é número, mostrar o número como secundário
																!isJustNumber && participant.participantNumber 
																	? participant.participantNumber 
																	: null
															}
														/>
														{participant.contactId && (
															<ListItemSecondaryAction>
																<Tooltip title={i18n.t("contactDrawer.members.startConversation")}>
																	<IconButton
																		edge="end"
																		size="small"
																		className={classes.chatButton}
																		onClick={() => handleStartConversation(participant)}
																		disabled={isLoading}
																	>
																		{isLoading ? (
																			<CircularProgress size={18} />
																		) : (
																			<ChatIcon fontSize="small" />
																		)}
																	</IconButton>
																</Tooltip>
															</ListItemSecondaryAction>
														)}
													</ListItem>
												</React.Fragment>
											);
										})}
									</List>
								) : (
									<Typography variant="body2" style={{ color: "#666", padding: 8 }}>
										{i18n.t("contactDrawer.members.loadError")}
									</Typography>
								)}
							</Paper>
						)}
					</div>
				)}
			</Drawer>
			<MergeContactModal
				open={mergeModalOpen}
				onClose={() => setMergeModalOpen(false)}
				contact={contact}
				onMergeSuccess={handleMergeSuccess}
			/>
			{/* Modal para criar novo ticket com participante */}
			<NewTicketModal
				modalOpen={newTicketModalOpen}
				onClose={handleCloseNewTicketModal}
				initialContact={selectedParticipantContact}
			/>
			{mediaViewerItem && (
				<MediaGalleryViewer
					open
					onClose={() => setMediaViewerItem(null)}
					initialItem={mediaViewerItem}
					source={mediaGallerySource}
					onGoToMessage={(item) => handleOpenFavoriteMessage(item.message)}
				/>
			)}
		</>
	);
};

export default ContactDrawer;
